import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css'; // Optional external CSS

const CustomTour = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/meal');
  };

  // Image list
  const images = [
    "./images/Ty.png",

  ];

  // State for random selection
  const [selectedImages, setSelectedImages] = useState([]);

  useEffect(() => {
    // Shuffle and pick 3 unique images
    const shuffled = images.sort(() => 0.5 - Math.random());
    setSelectedImages(shuffled.slice(0, 3));
  }, []);

  return (
    <div className="custom-tour-container">
      <div className="left-column">
        <h3>A Flavor to Remember</h3>
        <h2>Introducing Our New Dishes</h2>
        <h3>Crafted Just for You</h3>
        <button className="tour-button2" onClick={handleClick}>
          Taste the Experience
        </button>
      </div>

      <div className="right-column">
        {selectedImages.map((img, index) => (
          <img
            key={index}
            src={img}
            className="random-food-image"
          />
        ))}
      </div>
    </div>
  );
};

export default CustomTour;
